import ZoneCrud from './ZoneCrud'
export {ZoneCrud}
export default ZoneCrud
